export const GET_V2_TRAINING_MODULES_REQUEST = 'GET_V2_TRAINING_MODULES_REQUEST'
export const GET_V2_TRAINING_MODULES_SUCCESS = 'GET_V2_TRAINING_MODULES_SUCCESS'
export const GET_V2_TRAINING_MODULES_FAILURE = 'GET_V2_TRAINING_MODULES_FAILURE'

export const CREATE_V2_TRAINING_MODULE_REQUEST = 'CREATE_V2_TRAINING_MODULE_REQUEST'
export const CREATE_V2_TRAINING_MODULE_SUCCESS = 'CREATE_V2_TRAINING_MODULE_SUCCESS'
export const CREATE_V2_TRAINING_MODULE_FAILURE = 'CREATE_V2_TRAINING_MODULE_FAILURE'

export const UPDATE_V2_TRAINING_MODULE_REQUEST = 'UPDATE_V2_TRAINING_MODULE_REQUEST'
export const UPDATE_V2_TRAINING_MODULE_SUCCESS = 'UPDATE_V2_TRAINING_MODULE_SUCCESS'
export const UPDATE_V2_TRAINING_MODULE_FAILURE = 'UPDATE_V2_TRAINING_MODULE_FAILURE'

export const ARCHIVE_V2_TRAINING_MODULE_REQUEST = 'ARCHIVE_V2_TRAINING_MODULE_REQUEST'
export const ARCHIVE_V2_TRAINING_MODULE_SUCCESS = 'ARCHIVE_V2_TRAINING_MODULE_SUCCESS'
export const ARCHIVE_V2_TRAINING_MODULE_FAILURE = 'ARCHIVE_V2_TRAINING_MODULE_FAILURE'

export const UNARCHIVE_V2_TRAINING_MODULE_REQUEST = 'UNARCHIVE_V2_TRAINING_MODULE_REQUEST'
export const UNARCHIVE_V2_TRAINING_MODULE_SUCCESS = 'UNARCHIVE_V2_TRAINING_MODULE_SUCCESS'
export const UNARCHIVE_V2_TRAINING_MODULE_FAILURE = 'UNARCHIVE_V2_TRAINING_MODULE_FAILURE'



// WEBPACK FOOTER //
// ./src/constants/v2_training_modules.js